import script from "./Settings.vue?vue&type=script&setup=true&lang=js"
export * from "./Settings.vue?vue&type=script&setup=true&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=672cff38&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=672cff38&lang=css"
import "./Settings.vue?vue&type=style&index=2&id=672cff38&scoped=true&lang=css"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672cff38"]])

export default __exports__